import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IVehicleSell } from "./type";
import { RequestStatus } from "@app/constants";

const initialState: IVehicleSell = {
  sellCar: {},
};

const slice = createSlice({
  name: "sellCar",
  initialState,
  reducers: {
    sellCar(state, action: PayloadAction<any>) {
      state.sellCar.status = RequestStatus.RUNNING;
    },
    sellCarSuccess(state, action) {
      state.sellCar.status = RequestStatus.SUCCESS;
      state.sellCar.data = action.payload;
    },
    sellCarFailed(state, action: PayloadAction<any>) {
      state.sellCar.status = RequestStatus.ERROR;
      state.sellCar.error = action.payload;
    },
  },
});

export default slice.reducer;
export const { sellCar,sellCarFailed,sellCarSuccess } = slice.actions;